import EasyPassClient from './EasyPassClient';
import JwtBaseClient from './JwtBaseClient';

export default class {
  constructor(user) {
    const headers = {
      'acv-client-version': import.meta.env.VITE_VERSION,
      'acv-client-type': 'desktop',
      'acv-client-os': 'web',
      'acv-client-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    this.easyPassClient = new EasyPassClient(user);
    this.jwtBaseClient = new JwtBaseClient(
      import.meta.env.VITE_MESSAGE_API_BASE_URI,
      'response.data.errors',
      headers,
    );
    this.apiVersion = 'v3';
    this.gatewayUri = 'api/acvapi';
    this.resourceUri = 'messages';
  }

  v2get(route, params = {}) {
    return this.easyPassClient.get(`${this.gatewayUri}/${this.apiVersion}/${this.resourceUri}/${route}`, params);
  }

  messageApiGet(route, params = {}) {
    return this.jwtBaseClient.get(`${this.apiVersion}/${this.resourceUri}/${route}`, params);
  }

  messageApiPost(route, params = {}) {
    return this.jwtBaseClient.post(`${this.apiVersion}/${this.resourceUri}/${route}`, params);
  }

  getAll(params) {
    return this.messageApiGet('all', params);
  }

  getRecent() {
    return this.messageApiGet('recent');
  }

  /* do not use messageApi for app launch message */
  getAppLaunchMessage() {
    return this.v2get(
      'app_launch',
      {
        // mark_seen: false, // DEBUG: Set to false to persist app launch message
      },
    );
  }

  markAllSeen() {
    return this.messageApiPost('seen');
  }

  markAllRead() {
    return this.messageApiPost('read');
  }

  markRead(messageId) {
    return this.messageApiPost(`${messageId}/read`);
  }
}
